/* unplugin-vue-components disabled */import { render } from "./SidePanel.vue?vue&type=template&id=57d165c0&scoped=true&ts=true"
import script from "./SidePanel.vue?vue&type=script&lang=ts"
export * from "./SidePanel.vue?vue&type=script&lang=ts"

import "./SidePanel.vue?vue&type=style&index=0&id=57d165c0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57d165c0"]])

export default __exports__